<template>
    <!-- Permitimos desbordamiento vertical en la tabla para los dropdowns flotantes -->
    <div class="tw:overflow-x-auto tw:md:overflow-visible">
        <table class="tw:w-full tw:text-xs tw:text-left tw:border-collapse" :class="tableSizeClass">
            <thead
                class="tw:bg-slate-50/70 tw:border-b tw:border-slate-100 tw:text-slate-600 tw:uppercase tw:tracking-wider">
                <slot name="header"></slot>
            </thead>
            <tbody class="tw:divide-y tw:divide-slate-100 tw:text-slate-600">
                <slot name="body"></slot>
            </tbody>
        </table>
        <div class="tw:p-4 tw:border-t tw:border-slate-100 tw:flex tw:justify-center tw:items-center">
            <slot name="footer"></slot>
        </div>
    </div>
</template>

<script>
export default {
    name: 'BaseTable',
    props: {
        // Define el tamaño de la tabla: 'compact', 'normal' o 'large'
        size: {
            type: String,
            default: 'normal',
            validator: (value) => ['compact', 'normal', 'large'].includes(value)
        }
    },
    computed: {
        tableSizeClass() {
            switch (this.size) {
                case 'compact':
                    return 'table-size-compact';
                case 'large':
                    return 'table-size-large';
                case 'normal':
                default:
                    return 'table-size-normal';
            }
        }
    }
}
</script>

<style>
/* Estilos dinámicos según el tamaño seleccionado */
.table-size-compact th {
    padding: 0.5rem 0.75rem;
    /* Más reducido */
}

.table-size-compact td {
    padding: 0.5rem 0.75rem;
}

.table-size-normal th {
    padding: 0.875rem 1.25rem;
    /* Estándar elegante */
}

.table-size-normal td {
    padding: 1rem 1.25rem;
}

.table-size-large th {
    padding: 1.25rem 1.5rem;
    /* Espacioso */
}

.table-size-large td {
    padding: 1.25rem 1.5rem;
}

/* Efecto hover global para las filas */
table tr:hover {
    background-color: rgba(248, 250, 252, 0.6);
    transition: background-color 0.15s ease;
}

/* Permite que las celdas no recorten elementos hijos posicionados de forma absoluta */
table td {
    position: relative;
}

/* Regla para evitar que el contenedor de la última fila recorte el menú */
table tbody tr {
    position: relative;
}
</style>